module.exports = __webpack_public_path__ + "img/scenario_05.583145a0.jpg";